// The feature names TypeScript names: the access model's keys (`backend/src/access.ts`). Every
// report and page id is in the generated `app.gen.ts` (`pnpm gen`, platform D147).

/** Production & Routing, read: every routing page, filters, exports, Ask AI — the Viewer Role too. */
export const FEATURE_ROUTING = "routing";

/**
 * Production & Routing, changes: every CRUD write of a routing entity (`writeFeature`) — editing lines,
 * approving, pickups, shipping, pre-routes, restoring, adding list values. Warehouse and Manager, never Viewer.
 */
export const FEATURE_ROUTING_WRITE = "routingWrite";

/** Managers: the order $ value, and editing, retiring, deleting and merging list values. */
export const FEATURE_ROUTING_MANAGER = "routingManager";

/**
 * The Admin page (Divisions): its list and every abbreviation write. The Manager Role's for now
 * (`backend/src/access.ts`); its own group later changes only that file and a `GROUP_*`.
 */
export const FEATURE_ROUTING_ADMIN = "routingAdmin";
